import Swiper from 'swiper';
// import 'magnific-popup';  // Make sure to import magnific popup

const ExperienceItemSlider = {
    _jExperienceSwiper : null,
    _swiperExpObj: '',
    init() {
        this._jExperienceSwiper = $('.experience__item_swiper');
        if (this._jExperienceSwiper.length > 0) {
            this.initSlider();
        }
       
    },
    initSlider() {
        const totalSlides = this._jExperienceSwiper.find('.swiper-slide').length; // Get the number of slides
        const shouldLoop = totalSlides >= 3; // Check if there are 3 or more slides
    
        // Initialize Swiper only if there are slides
        this._swiperExpObj = new Swiper(this._jExperienceSwiper[0], {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: shouldLoop, // Only enable loop if there are 3 or more slides
            autoplay: {
                delay: 6000,
                disableOnInteraction: true,
            },
            scrollbar: {
                el: '.swiper-experience-scrollbar',
                hide: totalSlides < 3, // Hide scrollbar if fewer than 3 slides
                draggable: true,
            },
            navigation: {
                nextEl: '.swiper-experience-next',
                prevEl: '.swiper-experience-prev',
                disabledClass: 'swiper-button-disabled', // Class to hide navigation when disabled
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
    
        // Hide navigation arrows if fewer than 3 slides
        if (totalSlides < 3) {
            document.querySelector('.swiper-experience-next').style.display = 'none';
            document.querySelector('.swiper-experience-prev').style.display = 'none';
        } else {
            document.querySelector('.swiper-experience-next').style.display = 'block';
            document.querySelector('.swiper-experience-prev').style.display = 'block';
        }
    },
    
    
}

export default ExperienceItemSlider;



// WEBPACK FOOTER //
// ./scripts/modules/components/_experience-item-slider.js